<template>
  <div class="order-list" id="orderList">
    <second-menu-link-content>
      <template v-slot:header>
        <span>订货单</span>
      </template>
      <template v-slot:content>
        <div
          v-show="operationList.findIndex(item => item === operationBtns.addOrderBtn) !== -1"
          class="btn-container"
        >
          <el-button class="btn-blue" @click="addOrder">新增订单</el-button>
        </div>
        <div class="filter-order-condition" ref="filterOrderContainerEle">
          <el-form ref="filterOrderFormEle" :model="optionsForm">
            <div class="container">
              <el-form-item class="item" label="订单号：" prop="orderNum">
                <el-input
                  class="white"
                  clearable
                  v-model="optionsForm.orderNum"
                  @keyup.enter.native="filterOrder"
                  placeholder="请输入订单号"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="客户名称：" prop="userName">
                <el-autocomplete
                  class="customer-input"
                  popper-class="autocomplete-order"
                  v-model="optionsForm.userName"
                  ref="searchClientByTableEle"
                  type="text"
                  :fetch-suggestions="searchClientByInput"
                  placeholder="请输入客户名或手机号"
                  @select="onSelectClient"
                >
                </el-autocomplete>
              </el-form-item>
              <el-form-item class="item" label="订单状态：" prop="orderStatus">
                <el-select
                  class="white"
                  v-model="optionsForm.orderStatus"
                  placeholder="请选择订单状态"
                  clearable
                >
                  <el-option
                    v-for="item in orderStatusList"
                    :key="item.status"
                    :label="item.value"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="container">
              <el-form-item class="item paddingLeft" label="业务员：" prop="saleMan">
                <el-input
                  class="white"
                  clearable
                  v-model="optionsForm.saleMan"
                  @keyup.enter.native="filterOrder"
                  placeholder="请输入业务员"
                ></el-input>
              </el-form-item>
              <el-form-item class="item" label="付款状态：" prop="paymentStatus">
                <el-select
                  class="white"
                  v-model="optionsForm.paymentStatus"
                  placeholder="请选择付款状态"
                  clearable
                >
                  <el-option
                    v-for="item in payStatusList"
                    :key="item.status"
                    :label="item.value"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="item" label="付款方式：" prop="payMethod">
                <el-select
                  class="white"
                  clearable
                  v-model="optionsForm.payMethod"
                  placeholder="请选择付款方式"
                >
                  <el-option
                    v-for="item in payMethodList"
                    :key="item.status"
                    :label="item.value"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="container">
              <el-form-item class="item paddingLeft" label="收货人：" prop="receivedName">
                <el-input
                  class="white"
                  clearable
                  v-model="optionsForm.receivedName"
                  placeholder="请输入收货人名称"
                ></el-input>
              </el-form-item>
              <el-form-item class="item no-right" label="商品筛选：" prop="goodsName">
                <el-input
                  class="white"
                  clearable
                  v-model="optionsForm.goodsName"
                  @keyup.enter.native="filterOrder"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
              <div class="goods-tips">使用商品筛选搜索条件，只可查询近1年的订单</div>
            </div>
            <div class="container">
              <el-form-item class="item item-time" label="下单时间：" prop="orderTime">
                <el-date-picker
                  :disabled="optionsForm.goodsName?true:false"
                  v-model="optionsForm.orderTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
              <el-form-item class="item" prop="isHide">
                <el-checkbox class="check" v-model="optionsForm.isHide" @change="changeIsInvalid"
                  >隐藏拒绝、作废记录</el-checkbox
                >
              </el-form-item>
            </div>
            <div class="container">
            </div>
            <div class="operations">
              <el-button class="btn-blue" @click="filterOrder">筛选</el-button>
              <el-button
                @click="exportExcel"
                v-show="operationList.findIndex(item => item === operationBtns.exportOrderBtn) !== -1"
                class="btn-white"
              >导出报表</el-button>
              <span class="reset-btn" @click="clearFilterCondition">清空筛选条件</span>
            </div>
          </el-form>
        </div>
        <div class="orders">
          <div class="order-type">
            <el-radio-group v-model="optionsForm.orderStatus" @change="onOrderStatusChange">
              <el-radio-button label>全部订单</el-radio-button>
              <el-radio-button :label="1">待审核</el-radio-button>
              <el-radio-button :label="5">待出库</el-radio-button>
              <el-radio-button :label="7">待发货</el-radio-button>
            </el-radio-group>
          </div>
          <div class="table" ref="orderList">
            <el-table class="table-container" :data="orderList" :row-class-name="tableRowClassName">
              <el-table-column label="订单号" prop="orderNum" width="200">
                <template slot-scope="scope">
                  <span>{{ scope.row.orderNum }}</span>
                  <img v-show="scope.row.isSelect == 1?true:false" class="sampleImg" src="../../../../assets/order/sample.png" alt="">
                </template>
              </el-table-column>
              <el-table-column label="下单时间" prop="orderTime" width="120"></el-table-column>
              <el-table-column label="客户名称" prop="userName" width="200">
                <template slot-scope="scope">
                  <p :title="scope.row.userName">{{ scope.row.userName }}</p>
                </template>
              </el-table-column>
              <el-table-column label="实付金额" prop="amount"></el-table-column>
              <el-table-column label="订单状态" prop="orderStatusDesc"></el-table-column>
              <el-table-column label="业务员" prop="salesMan"></el-table-column>
              <el-table-column label="付款方式/状态" prop="payMethodAndStatus"></el-table-column>
              <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                  <!-- 待付款 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 0">
                    <span class="column-btn detail-btn" @click="onView(scope.row)">查看</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待审核 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 1">
                    <span class="column-btn finance-btn" @click="onView(scope.row)">查看</span>
                    <span
                      v-show="operationList.findIndex(item => item === operationBtns.checkOrderBtn) !== -1"
                      class="column-btn check-btn"
                      @click="onCheck(scope.row)"
                    >审核</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 订单审核拒绝 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 3">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待财务审核 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 4">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <span
                      v-show="operationList.findIndex(item => item === operationBtns.checkFinanceBtn) !== -1"
                      class="column-btn"
                      @click="onCheck(scope.row)"
                    >审核</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待出库审核 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 5">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <span
                      v-show="operationList.findIndex(item => item === operationBtns.checkOutStoreBtn) !== -1"
                      class="column-btn"
                      @click="toOrderDetail(scope.row)"
                    >出库</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待发货 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 7">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <span
                      v-show="operationList.findIndex(item => item === operationBtns.toShippingBtn) !== -1"
                      class="column-btn"
                      @click="toOrderDetail(scope.row)"
                    >发货</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待收货 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 8">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 已完成 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 9">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 已取消 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 10">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                    <!-- 未支付 -->
                    <span  v-show="Number(scope.row.paymentStatus) === 0"  class="column-btn detail-btn" @click="onView(scope.row,4)">添加收款</span>
                  </div>
                  <!-- 待确认收款 -->
                  <div class="operation-container" v-show="Number(scope.row.orderStatus) === 11">
                    <span class="column-btn" @click="onView(scope.row)">查看</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import { getDBOperationPermission } from "common/js/storage";
import {
  payMethodStatusToDesc,
  dbOrderStatusToValue,
  formatTimeToDate,
} from "common/js/util.js";
import PaginationTpl from "base/PaginationTpl";
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import DBOrder from "models/db/order.js";
import DBExcel from "models/db/excel.js";
const dbOrder = new DBOrder();
const dbExcel = new DBExcel();
import DBClient from "models/db/client.js";
const dbClient = new DBClient();
// 页面按钮--订单导出 新增订单 订单修改 订单审核 财务审核 出库审核 发货
const EXPORT_ORDER = "ROLE_ORDER_export";
const ADD_ORDER = "ROLE_ORDER_add";
const UPDATE_ORDER = "ROLE_ORDER_update";
const CHECK_ORDER = "ROLE_ORDER_examine";
const CHECK_FINANCE = "ROLE_ORDER_pay_examine";
const CHECK_OUT_STORE = "ROLE_ORDER_outware_examine";
const TO_SHIPPING = "ROLE_ORDER_express";
const orderStatusMap = {
  waitPay: 0,
  waitCheckOrder: 1,
  passCheckOrder: 2,
  rejectCheckOrder: 3,
  waitCheckFinance: 4,
  waitCheckOutStore: 5,
  waitShip: 7,
  waitReceive: 8,
  hasCompleted: 9,
  hasCanceled: 10,
};
export default {
  watch: {
    // 监听商品标签（最多只能选择一个）
    "optionsForm.userName": {
      handler(newName, oldName) {
        if (newName === '') {
          this.optionsForm.userId = ''
        }
      },
      deep: true,
    },
    "optionsForm.goodsName": {
      handler(newName, oldName) {
        if (newName) {
          this.optionsForm.orderTime = null
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      // 当前页面
      currentPage: 1,
      // 订单总条数
      totalNum: 0,
      // 筛选条件表单
      optionsForm: {
        orderNum: "",
        userId: "",
        saleMan: "",
        userName: "",
        orderStatus: "",
        paymentStatus: "",
        payMethod: "",
        goodsName: "",
        orderTime: null,
        isHide: true,
        receivedName: ''
      },
      // 所有付款方式
      payMethodList: [
        {
          status: 1,
          value: "线下付款",
        },
        {
          status: 2,
          value: "支付宝",
        },
        {
          status: 5,
          value: "微信",
        },
      ],
      // 所有订单状态
      orderStatusList: [
        {
          status: 0,
          value: "待付款",
        },
        {
          status: 1,
          value: "待订单审核",
        },
        {
          status: 3,
          value: "订单审核拒绝",
        },
        {
          status: 4,
          value: "待财务审核",
        },
        {
          status: 5,
          value: "待出库审核",
        },
        {
          status: 7,
          value: "待发货",
        },
        {
          status: 8,
          value: "待收货",
        },
        {
          status: 9,
          value: "已完成",
        },
        {
          status: 10,
          value: "已取消",
        },
      ],
      //付款状态
      payStatusList: [
        {
          status: 0,
          value: '未支付'
        },
        {
          status: 1,
          value: '已支付'
        },
        {
          status: 2,
          value: '已关闭'
        }
      ],
      // 订单列表
      orderList: [],
      // 具体查询参数
      options: {
        // 当前页面
        currentPage: 1,
        // 筛选条件--订单编号
        orderCode: "",
        // 筛选条件--客户名称
        userId: "",
        // 筛选条件--订单状态
        status: "",
        // 筛选条件--付款方式
        paymentMethod: "",
        // 筛选条件--开始时间
        startTime: "",
        // 筛选条件--结束时间
        endTime: "",
        // 筛选条件--业务员
        saleMan: "",
        goodsName: "",
        isHide: 1,
        // 筛选条件--收货人名称
        receivedName: ''
      },
      // 页面操作按钮
      operationBtns: {
        exportOrderBtn: EXPORT_ORDER,
        addOrderBtn: ADD_ORDER,
        updateOrderBtn: UPDATE_ORDER,
        checkOrderBtn: CHECK_ORDER,
        checkFinanceBtn: CHECK_FINANCE,
        checkOutStoreBtn: CHECK_OUT_STORE,
        toShippingBtn: TO_SHIPPING,
      },
      // 用户权限列表
      operationList: [],
      // 外部客户搜索框列表
      serachClientList: [],
    };
  },
  methods: {
    // 输入框查询客户
    searchClientByInput(query, cb) {
      let options = {
        name: query,
        isDiffAuth: 0
      };
      this._searchClientByInput(options, cb);
    },
    // 根据客户姓名关键字查询客户
    _searchClientByInput(options, cb) {
      dbClient.getClientList(options).then((res) => {
        if (res.success) {
          this.serachClientList = [];
          res.result.items.map((item) => {
            if (item.name || item.telephone) {
              this.serachClientList.push({
                value: `${item.name ? item.name + ";" : ""}${item.telephone}`,
                id: item.userId,
              });
            }
          });
          cb(this.serachClientList);
        }
      });
    },
    onSelectClient(item) {
      this.optionsForm.userId = item.id;
    },
    // 跳转订单出货/发货信息tab
    toOrderDetail(item) {
      let orderCode = item.orderCode;
      this.$router.push({
        path: "/admin/order/order-form/order-detail",
        query: {
          orderCode: orderCode,
          showShip: "showShip",
        },
      });
    },
    // 查看
    onView(item, isTabs) {
      let orderCode = item.orderCode;
      let orderId = item.orderId;
      if (isTabs) {
        this.$router.push({
          path: "/admin/order/order-form/order-detail",
          query: {
            orderCode: orderCode,
            isTabs: isTabs,
            orderId
          },
        });
      } else {
        this.$router.push({
          path: "/admin/order/order-form/order-detail",
          query: {
            orderCode: orderCode,
            isTabs: 0,
            orderId
          },
        });
      }
    },
    // 审核
    onCheck(item) {
      let data = {
        orderCode: item.orderCode,
      };
      switch (item.orderStatus) {
        // 订单审核
        case orderStatusMap.waitCheckOrder:
          this.$confirm(
            `是否确认订单${item.orderCode}通过订单审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "拒绝",
              distinguishCancelAndClose: true,
              type: "warning",
            }
          )
            .then((action) => {
              // 订单审核通过
              data.flag = 1;
              this._checkOrder(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 订单审核不通过
                data.flag = 0;
                this._checkOrder(data);
              }
            });
          break;
        case orderStatusMap.waitCheckFinance:
          // 财务审核
          this.$confirm(
            `是否确认订单${item.orderCode}通过财务审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              // 财务审核通过
              this._checkFinance(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 什么也不做
                return "";
              }
            });
          break;
        case orderStatusMap.waitCheckOutStore:
          this.$confirm(
            `是否确认订单${item.orderCode}通过出库审核`,
            "操作提示",
            {
              confirmButtonText: "通过",
              cancelButtonText: "取消",
              type: "warning",
            }
          )
            .then(() => {
              // 出库审核
              this._checkOutStore(data);
            })
            .catch((action) => {
              if (action === "cancel") {
                // 什么也不做
                return "";
              }
            });
          break;
        default:
          break;
      }
    },
    onQueryChange(query) {
      // 翻页
      this.options.currentPage = query.currentPage;
      this._getDBAllOrderList(this.options);
    },
    // 通过订单状态筛选订单
    onOrderStatusChange(orderStatus) {
      this.options.status = orderStatus;
      this._getDBAllOrderList();
    },
    changeIsInvalid() {
      this.options.isHide = this.optionsForm.isHide?1:0;
      this._getDBAllOrderList();
    },
    // 筛选订单
    filterOrder() {
      this.currentPage = 1;
      let startTime = "";
      let endTime = "";
      if (this.optionsForm.orderTime) {
        startTime = this.optionsForm.orderTime[0];
        endTime = this.optionsForm.orderTime[1];
      }
      this.options = Object.assign(this.options, {
        currentPage: this.currentPage,
        orderCode: this.optionsForm.orderNum,
        receivedName: this.optionsForm.receivedName,
        userId: this.optionsForm.userId,
        status: this.optionsForm.orderStatus,
        paymentStatus: this.optionsForm.paymentStatus,
        paymentMethod: this.optionsForm.payMethod,
        startTime: startTime,
        endTime: endTime,
        saleMan: this.optionsForm.saleMan,
        goodsName: this.optionsForm.goodsName,
        isHide: this.optionsForm.isHide?1:0,
      });
      this._getDBAllOrderList();
    },
    // 导出退货单表单
    exportExcel() {
      let orderCode = this.options.orderCode;
      let receivedName = this.options.receivedName;
      let endTime = this.options.endTime;
      let startTime = this.options.startTime;
      let userId = this.options.userId;
      let status = this.options.status;
      let paymentMethod = this.options.paymentMethod;
      let saleMan = this.options.saleMan;
      let options = {
        receivedName,
        orderCode,
        endTime,
        startTime,
        userId,
        status,
        paymentMethod,
        saleMan
      };
      dbExcel.getOrderExcel(options).then((res) => {
        let blob = new Blob([res.data], { type: res.headers.contentType });
        let fileName = window.decodeURI(
          res.headers["content-disposition"].split("=")[1]
        );
        var url = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        // 释放之前创建的URL对象
        window.URL.revokeObjectURL(url);
      });
    },
    clearFilterCondition() {
      this.optionsForm.userId = '';
      this.$refs.filterOrderFormEle.resetFields();
      this.filterOrder();
    },
    addOrder() {
      this.$router.push({
        path: "/admin/order/order-form/add-order",
      });
    },
    // 订单审核
    _checkOrder(data) {
      dbOrder.checkOrder(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          // 刷新页面数据
          this._getDBAllOrderList();
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 财务审核
    _checkFinance(data) {
      dbOrder.checkFinance(data).then((res) => {
        if (res.success) {
          // 刷新页面数据
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          this._getDBAllOrderList();
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 出库审核
    _checkOutStore(data) {
      dbOrder.checkOutStore(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            center: true,
            message: "审核成功",
            duration: 1000,
          });
          // 刷新页面数据
          this._getDBAllOrderList();
        } else {
          this.$message({
            type: "error",
            center: true,
            message: res.message,
            duration: 1000,
          });
        }
      });
    },
    // 获取所有订单列表
    _getDBAllOrderList() {
      // console.log("当前筛选条件--", this.options);
      dbOrder.getDBOrderList(this.options).then((res) => {
        if (res.success) {
          let { currentPage, totalNum, items } = res.result;
          this.currentPage = currentPage;
          this.totalNum = totalNum;
          this.orderList = [];
          items.map((item) => {
            // 订单状态描述
            let orderStatusValue = dbOrderStatusToValue(item.status);
            let payMethodAndStatus;
            // 先判断是否支付
            if (item.paymentStatus === 1) {
              // 已支付
              payMethodAndStatus = `${payMethodStatusToDesc(
                item.paymentMethod
              )}/已支付`;
            } else if (item.paymentStatus === 0) {
              payMethodAndStatus = "未支付";
            } else {
              payMethodAndStatus = "已关闭";
            }
            this.orderList.push({
              orderCode: item.orderCode,
              isInvalid: item.isInvalid,
              orderNum: item.orderCode,
              orderTime: formatTimeToDate(item.createTime),
              userName: item.userName,
              amount: item.paymentPrice,
              salesMan: item.salesMan,
              orderStatus: item.status,
              orderStatusDesc: orderStatusValue,
              paymentStatus: item.paymentStatus,
              payMethodAndStatus: payMethodAndStatus,
              isSelect: item.isSelect,
              orderId: item.id
            });
            console.log("筛选后订单--", this.orderList);
          });
        }
      });
    },
    /* 为 Table 中的某一行添加 class */
    tableRowClassName({row}) {
      if (row.isInvalid !== 1) {
        return '';
      }
      return 'active';
    },
  },
  activated() {
    if (this.$route.params.change) {
      this._getDBAllOrderList();
    }
  },
  created() {
    if (this.$route.query.status) {
      this.optionsForm.orderStatus = Number(this.$route.query.status);
      this.options.status = Number(this.$route.query.status);
    }
    this._getDBAllOrderList();
    this.operationList = getDBOperationPermission();
  },
  components: {
    PaginationTpl,
    SecondMenuLinkContent,
  },
};
</script>

<style lang="scss" scoped>
.order-list {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .sampleImg {
    margin-left: 5px;
  }
  .filter-order-condition {
    margin-top: 16px;
    padding: 16px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .container {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      &:first-child {
        padding-left: 14px;
      }
      .paddingLeft {
        padding-left: 14px;
      }
      .item {
        margin-right: 24px;
      }
      .goods-tips {
        font-size: 12px;
        line-height: 44px;
      }
      .no-right {
        margin-right: 8px;
      }
    }
    .operations {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding-left: 80px;
      .el-button + .el-button {
        margin-left: 16px;
      }
      .btn-white {
        width: 128px;
        letter-spacing: 4px;
      }
      .reset-btn {
        cursor: pointer;
        font-size: 12px;
        font-family: "PingFangSC-Regular";
        font-weight: 400;
        color: rgba(61, 116, 242, 1);
        margin-left: 20px;
      }
    }
  }
  .orders {
    margin-top: 24px;
    .column-btn {
      font-size: 12px;
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      color: rgba(61, 116, 242, 1);
      cursor: pointer;
      margin-right: 16px;
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
#orderList {
  .customer-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
    }
  }
  .el-form {
    .el-checkbox__input.is-checked + .el-checkbox__label,
    .el-checkbox__label {
      color: #666;
    }
    .el-form-item {
      display: flex;
      .el-form-item__content {
        width: 160px;
      }
    }
    .item-time {
      .el-form-item__content {
        width: 360px;
      }
    }
  }
  .table {
    box-sizing: border-box;
    .el-table {
      width: 100%;
      overflow: auto;
      box-sizing: border-box;
      .el-table__body-wrapper {
        .el-table__body {
          padding-bottom: 0px;
          .active {
            .tr,td {
              .cell {
                font-size: 14px;
                font-weight: 400;
                color: #C8C8C8;
              }
            }
          }
        }
      }
      .el-table__fixed-right {
        .el-table__header {
          thead {
            tr {
              th:nth-child(7) {
                box-sizing: border-box;
                padding: 0;
                margin: 0;
                .cell {
                  height: 32px;
                }
                background: rgba(245, 247, 250, 1);
              }
            }
          }
        }
        .el-table__body {
          padding-bottom: 10px;
          tbody {
            tr {
              td:nth-child(7) {
                padding: 0;
                margin: 0;
                height: 32px;
                .cell {
                  height: 32px;
                }
              }
            }
          }
        }
      }
      .el-table__fixed-right {
        box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.11);
        th {
          .cell {
            text-align: center;
          }
        }
        td {
          padding: 0;
          .cell {
            height: 32px;
            line-height: 32px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            .up-down-update {
              flex: 2;
              display: flex;
              justify-content: space-around;
              .update {
                margin-right: 5px;
              }
            }
            > .el-button {
              flex: 1;
            }
          }
          background: rgba(245, 247, 250, 1);
          .el-button--text {
            color: #3d74f2;
            font-size: 12px;
          }
        }
      }
    }
  }
}

.autocomplete-order {
  width: 320px!important;
}
</style>
